export default __webpack_public_path__ + "static/media/news.b3e30440.png";